// assets
import { IconDashboard } from '@tabler/icons';

// constant
const icons = { IconDashboard };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: 'پیشخوان',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'پیشخوان',
            type: 'item',
            url: '/dashboard',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'wallet',
            title: 'کیف پول',
            type: 'item',
            url: '/wallet',
            icon: icons.IconWallet
        },
        {
            id: 'account',
            title: 'شماره حساب‌ها',
            type: 'item',
            url: '/account',
            icon: icons.IconBuildingBank
        }
    ]
};

export default dashboard;
